export default "__VITE_ASSET__666f1fdc__"